export default {"src":"/_next/static/media/PDF.893f6d47.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};